import { Controller } from "@hotwired/stimulus"

// Controller pour le wizard de création de promotion
// Gère la navigation entre les étapes et la validation progressive
export default class extends Controller {
  static targets = ["step", "indicator", "prevButton", "nextButton", "submitButton"]
  static values = {
    current: { type: Number, default: 0 },
    total: { type: Number, default: 3 }
  }

  connect() {
    this.showStep(this.currentValue)
  }

  next() {
    if (this.validateCurrentStep()) {
      if (this.currentValue < this.totalValue - 1) {
        this.currentValue++
        this.showStep(this.currentValue)
      }
    }
  }

  previous() {
    if (this.currentValue > 0) {
      this.currentValue--
      this.showStep(this.currentValue)
    }
  }

  goToStep(event) {
    const stepIndex = parseInt(event.currentTarget.dataset.step, 10)
    if (stepIndex <= this.currentValue) {
      this.currentValue = stepIndex
      this.showStep(this.currentValue)
    }
  }

  showStep(index) {
    this.stepTargets.forEach((step, i) => {
      step.classList.toggle("hidden", i !== index)
    })

    this.updateIndicators(index)
    this.updateButtons(index)
  }

  updateIndicators(currentIndex) {
    this.indicatorTargets.forEach((indicator, i) => {
      const circle = indicator.querySelector("[data-circle]")
      const line = indicator.querySelector("[data-line]")
      const label = indicator.querySelector("[data-label]")

      if (i < currentIndex) {
        // Étape complétée
        circle.classList.remove("bg-white", "border-gray-300", "text-gray-500", "bg-blue-600", "border-blue-600", "text-white")
        circle.classList.add("bg-green-600", "border-green-600", "text-white")
        circle.innerHTML = '<i class="fa-solid fa-check text-sm"></i>'
        if (label) {
          label.classList.remove("text-gray-500", "text-blue-600", "font-medium")
          label.classList.add("text-green-600")
        }
        if (line) {
          line.classList.remove("bg-gray-200")
          line.classList.add("bg-green-600")
        }
      } else if (i === currentIndex) {
        // Étape actuelle
        circle.classList.remove("bg-white", "border-gray-300", "text-gray-500", "bg-green-600", "border-green-600")
        circle.classList.add("bg-blue-600", "border-blue-600", "text-white")
        circle.innerHTML = i + 1
        if (label) {
          label.classList.remove("text-gray-500", "text-green-600")
          label.classList.add("text-blue-600", "font-medium")
        }
      } else {
        // Étape future
        circle.classList.remove("bg-blue-600", "border-blue-600", "text-white", "bg-green-600", "border-green-600")
        circle.classList.add("bg-white", "border-gray-300", "text-gray-500")
        circle.innerHTML = i + 1
        if (label) {
          label.classList.remove("text-blue-600", "text-green-600", "font-medium")
          label.classList.add("text-gray-500")
        }
        if (line) {
          line.classList.remove("bg-green-600")
          line.classList.add("bg-gray-200")
        }
      }
    })
  }

  updateButtons(currentIndex) {
    const isFirstStep = currentIndex === 0
    const isLastStep = currentIndex === this.totalValue - 1

    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.classList.toggle("hidden", isFirstStep)
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("hidden", isLastStep)
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.toggle("hidden", !isLastStep)
    }
  }

  validateCurrentStep() {
    const currentStep = this.stepTargets[this.currentValue]
    const requiredFields = currentStep.querySelectorAll("[required]")
    let isValid = true

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        isValid = false
        field.classList.add("border-red-500")
        this.showFieldError(field)
      } else {
        field.classList.remove("border-red-500")
        this.hideFieldError(field)
      }
    })

    return isValid
  }

  showFieldError(field) {
    const wrapper = field.closest(".form-group") || field.parentElement
    let errorElement = wrapper.querySelector(".field-error")

    if (!errorElement) {
      errorElement = document.createElement("p")
      errorElement.className = "field-error text-red-500 text-sm mt-1"
      errorElement.textContent = "Ce champ est requis"
      wrapper.appendChild(errorElement)
    }
  }

  hideFieldError(field) {
    const wrapper = field.closest(".form-group") || field.parentElement
    const errorElement = wrapper.querySelector(".field-error")
    if (errorElement) {
      errorElement.remove()
    }
  }
}
